import React from 'react'

const Contacto = () => {
  return (
    <div className='h-full text-xl'>contacto
    <div className='h-screen'></div></div>
  )
}

export default Contacto